import React, { useState } from 'react'
import TransactionTable from './component/TransactionTable'
import CustomPagination from 'components/molecules/CustomPagination'
import EmptyList from 'components/molecules/EmptyList'
import { useQuery } from 'react-query'
import { getTransactions } from 'api'
import { showErrorMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'

const initialFilterTransaction = {
  page: 1,
  pageSize: 25,
  sort: 'created_at-'
}
const Transaction = () => {
  const [filter, setFilter] = useState({
    ...initialFilterTransaction
  })

  function updateFilter(key, value) {
    return setFilter((prev) => ({ ...prev, [key]: value }))
  }

  const { data: transactionList } = useQuery({
    queryKey: ['getTransactionsQuery', filter],
    queryFn: () => {
      let params = {
        page: filter.page,
        limit: filter?.pageSize,
        sort: filter?.sort
      }
      return getTransactions({ params })
    },
    onError: (err) => {
      return showErrorMessage(getErrorMessage(err))
    }
  })
  // Handle pagination change
  const handlePageChange = (page) => {
    updateFilter('page', page)
  }
  // Handle pagination change
   const handlePageSizeChange = (pageSize) => {
      setFilter((prev) => ({ ...prev, pageSize, page: 1 }))
   }

  return (
    <div className="flex flex-col gap-8">
      <p className="text-2xl font-medium">Transaksi</p>
      {transactionList?.data?.length > 0 ? (
        <>
          <TransactionTable data={transactionList?.data ?? []} />
          <CustomPagination
            isShowPageSize
            totalData={transactionList?.meta?.total}
            pageSize={filter.pageSize}
            currentPage={filter.page}
            onPageSizeChange={handlePageSizeChange}
            onPaginationChange={handlePageChange}
          />
        </>
      ) : (
        <EmptyList category={'transaction'} />
      )}
    </div>
  )
}

export default Transaction
